import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'de', label: 'DE' },
    { code: 'fr', label: 'FR' }
  ];

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    try {
      localStorage.setItem('i18nextLng', languageCode);
    } catch (e) {
      // ignore storage errors
    }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = languageCode;
    }
  };




  return (
    <div className={`flex items-center space-x-1 ${className}`} >
      {languages.map((language, index) => (
        <React.Fragment key={language.code}>
          <button
            onClick={() => handleLanguageChange(language.code)}
            className="px-2 py-1 text-sm font-sofia font-medium transition-colors duration-200 hover:text-accent"
            style={{
              color: i18n.language === language.code ? '#FF0000' : '#796d66'
            }}
          >
            {language.label}
          </button>
          {index < languages.length - 1 && (
            <span className="text-sm" style={{ color: '#796d66', opacity: 0.6 }}>|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
